var render, staticRenderFns
import script from "./smooth-wrapper.vue?vue&type=script&lang=js&"
export * from "./smooth-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./smooth-wrapper.vue?vue&type=style&index=0&id=6fe7597e&prod&scoped=true&lang=css&"
import style1 from "./smooth-wrapper.vue?vue&type=style&index=1&id=6fe7597e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe7597e",
  null
  
)

export default component.exports